export default "__VITE_ASSET__Base_zjM__"